/* template */
<template><es-drawer-bottom :show="(cxvipPopupShow)" showDefaultNav :navbarStyle="({background: 'transparent'})" :customStyle="({height: '350px'})" @close="close"><div class="container"><mpx-image :src="(vipicon)" class="vip-icon"></mpx-image><div class="title">开通12306畅行会员</div><div class="sub-title">开通会员，享受<span class="highlight">双渠道抢票权益</span></div><mpx-view @tap="toOpenCxvip" class="open-btn">立即开通</mpx-view></div></es-drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m6722e351"}'>
  .container
    padding 0 20px
    box-sizing border-box
    display flex
    flex-direction column
    align-items center
    line-height 1
    .vip-icon
      margin -24px 0 17px
      width 110px
      height 110px
    .title
      font-family AlibabaPuHuiTi PingFangSC-Medium
      font-size 20px
      font-weight 500
      letter-spacing 0px
      color #000000
    .sub-title
      font-family PingFangSC-Regular
      font-size 14px
      font-weight normal
      letter-spacing 0px
      color #3D3D3D
      margin-top 12px
      .highlight
        color #FF6400
    .open-btn
      width 100%
      height 44px
      @extend .flex-center
      justify-content center
      border-radius 10px
      background-color #338FFF
      color #FFFFFF
      font-family PingFangSC-Medium
      font-size 15px
      font-weight normal
      letter-spacing 0px
      margin-top 57px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6722e351"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./cxvip-popup.mpx.js?isComponent&outputPath=components%2Fcxvip-popup6722e351%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./cxvip-popup.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcxvip-popup6722e351%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6722e351"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/cxvip-popup6722e351/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-drawer-bottom':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
